export default "__VITE_ASSET__frTLGBIO__"